export const FETCH_PROVIDER_GET_CONFIG_FAILURE = 'FETCH_PROVIDER_GET_CONFIG_FAILURE';
export const FETCH_PROVIDER_GET_CONFIG_REQUEST = 'FETCH_PROVIDER_GET_CONFIG_REQUEST';
export const FETCH_PROVIDER_GET_CONFIG_SUCCESS = 'FETCH_PROVIDER_GET_CONFIG_SUCCESS';
